const URL = {
  CHANGE_PASSWORD_USER: 'User/ChangePassword',
  PASSWORD_SET: 'User/SetPassword',
  RENEW_PASSWORD: 'auth/RenewPassword',
}

export default URL
